const audio = {
    audioUrl: '',
    // description: '',
    // title: '',
    featured: false,
};

const event = {
    alt: '',
    dateTime: '',
    eventName: '',
    eventUrl: '',
    groupName: '',
    location: '',
    venue: ''
};

const image = {
    caption: '',
    imageUrl: ''
};

const rec = {
    spotifyUrl: '',
    infoUrl: '',
    featured: false
};

const video = {
    youtubeUrl: '',
    featured: true
};

const group = {
    name: '',
    code: '',
    api: false
}

export {
    audio,
    event,
    image,
    rec,
    video,
    group,
};